import Grid from '@mui/material/Grid';

export const Cards: React.FC = ({ children }) => {
	return (
		<Grid
			container
			direction='row'
			justifyContent='flex-start'
			alignItems='center'
			spacing={2}
			columns={{ xs: 12, sm: 12, md: 12 }}
		>
			{children}
		</Grid>
	);
};
